import React from 'react';
import Allproductss from '../Components/Allproducts/Allproducts'

const Allproducts = () => {
  return (
    <div>
      {/* Aquí puedes dejar el contenido en blanco */}
      <h2 style={{ textAlign: 'center', marginTop: '20px' }}>Página en construcción</h2>
      <Allproductss/>
    </div>
    
    
  );
};

export default Allproducts;
